import {
  Activity, Award, BarChart3, Beer, Bell, Building2, Calendar, CalendarDays, Camera, Check, ClipboardList, Clock,
  Compass, Crown, Dices, Download, Flag, Gift, Globe, Handshake, Heart, HelpCircle, Image, Landmark, Layers,
  LayoutGrid, Link, ListChecks, Lock, Mail, Map, MapPin, MapPinned, Medal, Megaphone, MessageCircle, Newspaper,
  Play, Radio, Repeat, Rocket, Search, Settings, Share2, ShieldCheck, ShoppingBag, Smartphone, Sparkles, Star,
  Store, Swords, Table, Target, Ticket, TrendingUp, Trophy, Tv, UserPlus, Users, UsersRound, Video, Zap,
} from 'lucide-react';

// ============================================
// Icon-Registry für Landingpage-Blöcke (featureGrid.icon = lucide-Name in
// kebab-case, z. B. "map-pin"). Bewusst KEIN Import der kompletten
// lucide-Map (Bundle-Größe) – nur die Marketing-relevanten Icons; alles
// Unbekannte fällt auf ein Standard-Icon zurück.
// ============================================

export type LandingIcon = typeof Users;

const REGISTRY: Record<string, LandingIcon> = {
  activity: Activity,
  award: Award,
  'bar-chart-3': BarChart3,
  'bar-chart': BarChart3,
  chart: BarChart3,
  beer: Beer,
  bell: Bell,
  'building-2': Building2,
  building: Building2,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  camera: Camera,
  check: Check,
  'clipboard-list': ClipboardList,
  clock: Clock,
  compass: Compass,
  crown: Crown,
  dices: Dices,
  download: Download,
  flag: Flag,
  gift: Gift,
  globe: Globe,
  handshake: Handshake,
  heart: Heart,
  'help-circle': HelpCircle,
  'circle-help': HelpCircle,
  image: Image,
  landmark: Landmark,
  layers: Layers,
  'layout-grid': LayoutGrid,
  link: Link,
  'list-checks': ListChecks,
  lock: Lock,
  mail: Mail,
  map: Map,
  'map-pin': MapPin,
  'map-pinned': MapPinned,
  medal: Medal,
  megaphone: Megaphone,
  'message-circle': MessageCircle,
  newspaper: Newspaper,
  play: Play,
  radio: Radio,
  repeat: Repeat,
  rocket: Rocket,
  search: Search,
  settings: Settings,
  'share-2': Share2,
  share: Share2,
  'shield-check': ShieldCheck,
  shield: ShieldCheck,
  'shopping-bag': ShoppingBag,
  smartphone: Smartphone,
  sparkles: Sparkles,
  star: Star,
  store: Store,
  swords: Swords,
  table: Table,
  target: Target,
  ticket: Ticket,
  'trending-up': TrendingUp,
  trophy: Trophy,
  tv: Tv,
  'user-plus': UserPlus,
  users: Users,
  'users-round': UsersRound,
  video: Video,
  zap: Zap,
};

export const DEFAULT_LANDING_ICON: LandingIcon = Sparkles;

/** "MapPin", "map_pin", " Map-Pin " → "map-pin" (pure) */
export const normalizeIconName = (name: unknown): string =>
  typeof name === 'string'
    ? name.trim().replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase()
    : '';

/** Icon-Komponente zum Namen; unbekannt/leer → Standard-Icon. */
export const resolveLandingIcon = (name: unknown): LandingIcon => REGISTRY[normalizeIconName(name)] ?? DEFAULT_LANDING_ICON;

export const hasLandingIcon = (name: unknown): boolean => normalizeIconName(name) in REGISTRY;

export const LANDING_ICON_NAMES: string[] = Object.keys(REGISTRY).sort();
